import create from './create'
import edit from './edit'
import list from './list'

export default { list, edit, create, options: { label: 'Categories' } }
